export default ".fancy-box[data-v-082a0184] { z-index: 9999999999;\n}\n"